import React, { HTMLAttributes, ReactNode } from 'react';
import { SlickWrapper, Container } from './style';

interface ISlider extends HTMLAttributes<HTMLElement> {
  children?: ReactNode;
  settings?: any;
}

const SliderNews = (props: ISlider) => {
  const { children, settings, className } = props;

  return (
    <Container>
      <SlickWrapper
        {...settings}
        className={`sliderWrapper ${className}`}
      >
        {children}
      </SlickWrapper>
    </Container>
  );
};

export default SliderNews;
